<template>
  <v-row no-gutters :class="$vuetify.theme.dark?'grey-darken-3 pa-2 ':'white pa-2 '">
    <v-col cols="12">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle">
            {{ $language.jobDetails['Hired Applicants'] }}:
          </v-list-item-subtitle>
          <v-list-item-title class="headline font-weight-bold">
            {{(job.public||{}).hiredWorkers}}/{{(job.public||{}).workers}}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn block color="primary" @click="$emit('open-fav')" :disabled="buttonLoading" :loading="buttonLoading" class="" outlined>
            <div>
              {{ $language.jobDetails['Invite Workers'] }} <span >({{invitedFavorites}}/{{favCount}})</span>
            </div>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-col>

    <v-col cols="12" class="my-1 pb-7">
      <v-divider></v-divider>
    </v-col>
    <v-col cols="12" md="6" lg="12" class="px-1">
      <v-row>
        <v-col cols="12">
          <div class="body-2 font-weight-bold  mb-2">{{ $language.jobDetails['Hired Applicants'] }}</div>
          <v-divider></v-divider>
          <div class="mt-2" v-for="item in filterHired" :key="item.profileId">

            <profile-list-item :chat="true" :pay="true" :job="job" :color="''" :profile="item" @pay="handlePayIndividual(item)" @profile="openProfileDialog(item)" @message="messageApplicant(item)" :user-fav="userProfile.favorites"></profile-list-item>
          </div>
          <div v-if="filterHired.length === 0" class="body-1 grey--text text--darken-2 py-2 pl-2">
            {{ $language.jobDetails['You have not hired any worker.'] }}
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="12" class="px-1">
      <v-row>
        <v-col cols="12">
          <div class="body-2 font-weight-bold  mb-2">{{ $language.jobDetails['Pending Applicants'] }}</div>
          <v-divider></v-divider>
          <div class="mt-2" v-for="item in filterApplied" :key="item.profileId">

            <profile-list-item :chat="true" :profile="item" :job="job" :is-hefe="isHefe" :color="'grey darken-1'" @confirm-hire="confirmHire($event.profileId)" @profile="openProfileDialog(item)" @message="messageApplicant(item)" :user-fav="userProfile.favorites"></profile-list-item>
          </div>
          <div v-if="filterApplied.length === 0" class="body-1 grey--text text--darken-2 py-2 pl-2">
            {{ $language.jobDetails['There are no applications yet.'] }}
          </div>
        </v-col>
        <v-col cols="12">
          <div class="body-2 font-weight-bold  mb-2">{{ $language.jobDetails['Declined Applicants'] }}</div>
          <v-divider></v-divider>
          <div class="mt-2" v-for="item in filterDeclined" :key="item.profileId">
            <profile-list-item :chat="true" :profile="item" :job="job" :color="'red darken-2'" @confirm-hire="confirmHire($event.profileId)" @profile="openProfileDialog(item)" @message="messageApplicant(item)" :user-fav="userProfile.favorites"></profile-list-item>

          </div>
          <div v-if="filterDeclined.length === 0" class="body-1 grey--text text--darken-2 py-2 pl-2">
            {{ $language.jobDetails['You have not declined any application.'] }}
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>

</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import ProfileListItem from '@/components/jefe/applicants/ProfileListItem'
const fb = require('@/services/firebaseConfig.js')
export default {
  props: ['job', 'applicants', 'isHefe'],
  components: {
    ProfileListItem
  },
  data () {
    return {
      sub: '',
      buttonLoading: false

    }
  },

  computed: {
    ...mapState(['userProfile', 'currentUser']),
    filterApplied () {
      return Object.values(this.applicants || {}).filter(item => {
        return item.status === 'Applied'
      })
    },
    filterApproved () {
      return Object.values(this.applicants || {}).filter(item => {
        return item.status === 'Approved'
      })
    },
    filterHired () {
      return Object.values(this.applicants || {}).filter(item => {
        return item.status === 'Hired' || item.status === 'Started' || item.status === 'Completed' || item.status === 'Paid' || item.status === 'Pending Payment'
      })
    },
    filterDeclined () {
      return Object.values(this.applicants || {}).filter(item => {
        return item.status === 'Declined'
      })
    },
    filterWorkers () {
      return Object.values(this.applicants || {}).filter(item => {
        return item.status === 'Hired' || item.status === 'Started' || item.status === 'Completed' || item.status === 'Paid' || item.status === 'Pending Payment'
      })
    },
    invitedFavorites () {
      var favorites = Object.keys((this.userProfile || {}).favorites || {}).map(k => k)
      var applicants = Object.keys(this.applicants || {}).map(k => k)
      var count = favorites.map(k => {
        return applicants.includes(k)
      }).filter(Boolean).length
      return count
    },
    favCount () {
      return Object.keys((this.userProfile || {}).favorites || {}).map(k => k).length
    },
    hiredMax () {
      return !(parseInt(this.job.public.workers) - parseInt(this.job.public.hiredWorkers) > 0)
    }
  },
  methods: {
    confirmHire (profileId) {
      console.log('here')

      this.job._key = this.job.public._key
      this.job.applicants = this.applicants
      this.buttonLoading = true
      var newKey = fb.database.ref().child(`jobs`).push().key
      var updatedDate = new Date()

      var notification = {
        'notificationType': 'Hire Accepted',
        'notificationText': `Hired: ${this.job.public.title} \nView:${this.job.public.jobShortLink}`,
        'notificationDate': updatedDate,
        'jobId': this.job._key,
        'defaultTab': 'Status',
        route: 'obr'
      }

      var updates = {}
      if (this.job.public.bid) {
        if (this.job.public.rateType === 'Hourly') {
          updates[`/jobs/${this.job._key}/public/compensation`] = this.job.applicants[profileId].bid.rate
          updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/compensation`] = this.job.applicants[profileId].bid.rate
          updates[`/user/${profileId}/jobs/${this.job._key}/compensation`] = this.job.applicants[profileId].bid.rate
          updates[`/jobs/${this.job._key}/public/rate`] = this.job.applicants[profileId].bid.rate
          updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/rate`] = this.job.applicants[profileId].bid.rate
          updates[`/user/${profileId}/jobs/${this.job._key}/rate`] = this.job.applicants[profileId].bid.rate
        } else {
          updates[`/jobs/${this.job._key}/public/compensation`] = this.job.applicants[profileId].bid.fixedCost
          updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/compensation`] = this.job.applicants[profileId].bid.fixedCost
          updates[`/user/${profileId}/jobs/${this.job._key}/compensation`] = this.job.applicants[profileId].bid.fixedCost
          updates[`/jobs/${this.job._key}/public/fixedCost`] = this.job.applicants[profileId].bid.fixedCost
          updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/fixedCost`] = this.job.applicants[profileId].bid.fixedCost
          updates[`/user/${profileId}/jobs/${this.job._key}/fixedCost`] = this.job.applicants[profileId].bid.fixedCost
        }
        this.job.public.schedule = this.job.applicants[profileId].bid.schedule

        updates[`/jobs/${this.job._key}/public/schedule`] = this.job.public.schedule
        updates[`/jobs/${this.job._key}/public/startDate`] = this.job.applicants[profileId].bid.startDate
        updates[`/jobs/${this.job._key}/public/startTime`] = this.job.applicants[profileId].bid.startTime
        updates[`/jobs/${this.job._key}/public/endTime`] = this.job.applicants[profileId].bid.endTime
        updates[`/jobs/${this.job._key}/public/contractEndDate`] = this.job.applicants[profileId].bid.contractEndDate
        updates[`/jobs/${this.job._key}/public/scheduleText`] = this.job.applicants[profileId].bid.scheduleText
        updates[`/jobs/${this.job._key}/public/hours`] = this.job.applicants[profileId].bid.hours

        updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/schedule`] = this.job.public.schedule
        updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/startDate`] = this.job.applicants[profileId].bid.startDate
        updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/startTime`] = this.job.applicants[profileId].bid.startTime
        updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/endTime`] = this.job.applicants[profileId].bid.endTime
        updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/contractEndDate`] = this.job.applicants[profileId].bid.contractEndDate
        updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/scheduleText`] = this.job.applicants[profileId].bid.scheduleText
        updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/hours`] = this.job.applicants[profileId].bid.hours

        updates[`/user/${profileId}/jobs/${this.job._key}/startDate`] = this.job.applicants[profileId].bid.startDate
        updates[`/user/${profileId}/jobs/${this.job._key}/startTime`] = this.job.applicants[profileId].bid.startTime
        updates[`/user/${profileId}/jobs/${this.job._key}/schedule`] = this.job.public.schedule
        updates[`/user/${profileId}/jobs/${this.job._key}/endTime`] = this.job.applicants[profileId].bid.endTime
        updates[`/user/${profileId}/jobs/${this.job._key}/contractEndDate`] = this.job.applicants[profileId].bid.contractEndDate
        updates[`/user/${profileId}/jobs/${this.job._key}/scheduleText`] = this.job.applicants[profileId].bid.scheduleText
        updates[`/user/${profileId}/jobs/${this.job._key}/hours`] = this.job.applicants[profileId].bid.hours
        if (this.job.applicants[profileId].bid.dayToggle) {
          updates[`/jobs/${this.job._key}/public/dayToggle`] = this.job.applicants[profileId].bid.dayToggle
          updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/dayToggle`] = this.job.applicants[profileId].bid.dayToggle
          updates[`/user/${profileId}/jobs/${this.job._key}/dayToggle`] = this.job.applicants[profileId].bid.dayToggle
        }
      }
      updates[`/jobs/${this.job._key}/applicants/${profileId}/status`] = 'Hired'
      updates[`/jobs/${this.job._key}/applicants/${profileId}/updatedDate`] = updatedDate
      updates[`/jobs/${this.job._key}/applicants/${profileId}/hiredDate`] = updatedDate
      updates[`/user/${profileId}/jobs/${this.job._key}/status`] = 'Hired'
      updates[`/user/${profileId}/jobs/${this.job._key}/updatedDate`] = updatedDate
      updates[`/user/${profileId}/jobs/${this.job._key}/location`] = this.job.public.location
      updates[`/user/${profileId}/jobs/${this.job._key}/category`] = this.job.public.category
      updates[`/jobs/${this.job._key}/public/schedule`] = this.job.public.schedule

      updates[`/jobs/${this.job._key}/public/hiredWorkers`] = parseInt(this.job.public.hiredWorkers) + 1
      updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/hiredWorkers`] = parseInt(this.job.public.hiredWorkers) + 1
      updates[`jobs/${this.job._key}/public/numberOfApplicants`] = parseFloat(this.job.public.numberOfApplicants - 1)
      updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/numberOfApplicants`] = parseFloat(this.job.public.numberOfApplicants - 1)
      updates[`/user/${profileId}/profile/notifications/${newKey}`] = notification
      updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/workers/${this.currentUser.uid}`] = {
        name: this.userProfile.public.name,
        picture: this.userProfile.public.photoURL
      }
      if (parseInt(this.job.public.hiredWorkers) + 1 - parseInt(this.job.public.workers) === 0) {
        Object.keys(this.job.applicants).map(k => {
          if ((this.job.applicants[k].status === 'Invited' || this.job.applicants[k].status === 'Applied') && k !== profileId) {
            updates[`/user/${k}/profile/jobInvites/${this.job._key}`] = null
            updates[`/user/${k}/jobs/${this.job._key}`] = null
          }
        })

        updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/status`] = 'Scheduled'
        updates[`/jobs/${this.job._key}/public/status`] = 'Scheduled'
        updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/public/updatedDate`] = updatedDate
        updates[`/jobs/${this.job._key}/public/updatedDate`] = updatedDate
        updates[`/geofire/${this.job._key}/`] = null
      }
      fb.database.ref().update(updates)
      this.buttonLoading = false
    },
    handlePayIndividual (item) {
      // console.log(item)
      this.$emit('handle-pay-individual', item)
    }
  },
  watch: {
    applicants () {
      this.job.applicants = this.applicants
    }
  },
  filters: {

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(moment(`${this.job.startDate}T${val.h} ${val.mm} ${val.A}`, ['HH.mm a']).format('hh:mm a'))
      return moment(date).fromNow()
    },
    formatTime (val) {
      return moment(val).format('hh:mm:ss a')
    },
    formatHour (val) {
      if (!val) {
        return '-'
      }
      return val === parseInt(1) ? 'hour' : 'hours'
    },
    formatHoursWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 3600)
      return Math.round(val % 24)
    },
    formatMinWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 60)
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatSecWorked (val) {
      if (!val) {
        return '-'
      }
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    }
  }
}
</script>
